<div style='width:100%; font-family:Arial; width:660px'>
	<div style='margin:0; float:left; width:100%; padding:10px;'>

		<br />

		<button type="button" pButton icon="fa fa-refresh" (click)="updateStatus()" [disabled]="false" label="Refresh"
			title="Refresh discovery status"></button>

		<br />
		<br />

		<b style='font-size:24px'>Discovery Status</b>

		<br />

		<span *ngIf="state"><em>State: {{state}}</em><br /></span>
		<span *ngIf="startTime"><em>Start Time: {{startTime}}</em><br /></span>
		<span *ngIf="endTime"><em>End Time: {{endTime}}</em><br /></span>
		<span *ngIf="totalProgress"><em>Total Progress: {{totalProgress}}</em><br /></span>
		<span *ngIf="discoveryPhase"><em>Discovery Phase: {{discoveryPhase}}</em><br /></span>
		<span *ngIf="phaseProgress"><em>Phase Progress: {{phaseProgress}}</em><br /></span>
		<span *ngIf="lastDevice"><em>Last Device: {{lastDevice}}</em><br /></span>
		<br />

		<b style='font-size:24px'>Devices</b><br />

		<div *ngIf="allDevices > 0" style='width:100%; margin-bottom:10px; margin-top:10px;'>
			<table style='width:100%;'>
				<tr *ngFor="let row of deviceCountRows" style='padding-bottom:20px;'>
					<td *ngFor="let elem of row" style='width:25%;'>
						<img src='{{elem.image}}' style='float:left;'>
						<span style='float:left; margin-top:15px; margin-left:10px;'>{{elem.label}}</span>
					</td>
				</tr>
			</table>
		</div>

		<p *ngIf="allDevices == 0">None</p>

		<div *ngIf="isDiscoveryRunning">
			<br />
			<button type="button" pButton icon="fa fa-cancel" (click)="cancelDiscovery()" [disabled]="false"
				label="Cancel Discovery" title="Cancel discovery"></button>
			<br />
			<br />
			<b style='font-size:24px'>Task Status</b><br />
			<p-table [value]="subtaskStatusValues" dataKey="IpAddress">
				<ng-template pTemplate="header">
					<tr>
						<th style="width:3rem"></th>
						<th style="text-align:center">IP Address</th>
						<th style="text-align:center">Task Type</th>
						<th style="text-align:center">Run Time</th>
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-row let-expanded="expanded">
					<tr>
						<td style="text-align:center">
							<button type="button" pButton pRipple [pRowToggler]="row"
								[icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
								class="p-button-text p-button-rounded p-button-plain"></button>
						</td>
						<td style="text-align:center">{{row.IpAddress}}</td>
						<td style="text-align:center">{{row.TaskType}}</td>
						<td style="text-align:center">{{row.RunTime}}</td>
						<td style="text-align:center">
							<button type="button" pButton icon="fa fa-cancel" (click)="cancelSubtask(row)"
								label="Cancel Task" title="Cancel task"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-row>
					<tr>
						<td colspan="5">
							<p-table [value]="row.CollectorChainValues">
								<ng-template pTemplate="header">
					<tr>
						<th style="text-align:center">Collector Type</th>
						<th style="text-align:center">Info Set Name</th>
						<th style="text-align:center">Run Time</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-entry>
					<tr>
						<td style="text-align:center">{{entry.CollectorType}}</td>
						<td style="text-align:center">{{entry.InfoSetName}}</td>
						<td style="text-align:center">{{entry.RunTime}}</td>
					</tr>
				</ng-template>
			</p-table>
			</td>
			</tr>
			</ng-template>
			</p-table>
		</div>
	</div>
</div>